import React from "react";
import ServicesHeadPayers from "./ServiceHeadPayers";
import ServicesCardPayers from "./ServicesCardPayers";

const ServicesMainPayers = () => {
  return (
    <div>
      <ServicesHeadPayers />
      <ServicesCardPayers />
    </div>
  );
};

export default ServicesMainPayers;
